<template>
  <div id="show-client-portal-active-session">
    <v-card class="mt-3">
      <v-card-title>
        <span>Sessions actives |</span>
        <v-skeleton-loader
          type="card-heading"
          v-if="totalSessions == null"
        ></v-skeleton-loader>
        <span v-else class="ml-1 text-body-1">
          {{ totalSessions }}
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <active-session-datatable
          :is-portal-client="true"
          :is-card="false"
          :id="clientPortal.id"
          @update:total-sessions="totalSessions = $event"
        ></active-session-datatable>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { ref } from "@vue/composition-api";
import ActiveSessionDatatable from "@/components/ActiveSession/ActiveSessionDatatable";

export default {
  props: {
    clientPortal: Object,
  },
  components: { ActiveSessionDatatable },
  setup() {
    /* Variables */
    const totalSessions = ref(null);

    return {
      totalSessions,
    };
  },
};
</script>
